
function createChart(timestamps, prices) {
  var ctx = document.getElementById("dai-price-chart").getContext('2d');
  var labels = prices.map(function(v, idx) {
    if (idx == 0) return 'now';
    return idx + "h ago";
  }).reverse();
  var myChart = new Chart(ctx, {
    type: 'line',
    data: {
      labels: labels,
      datasets: [{
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderColor: 'rgb(255, 255, 255)',
//        backgroundColor: 'rgba(255, 99, 132, 0.5)',
//        borderColor: 'rgb(255, 99, 132)',
        data: prices,
        label: 'Dai Price (USD)',
        fill: 'start'
      }]
    },
    options: {
      title: { display: false },
      legend: { display: false },
      plugins: {
          filler: {
            propagate: true
          }
      },
      scales: {
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true,
              fontColor: "white"
            },
            scaleLabel: {
              display: true,
              labelString: '$ (USD)',
              fontColor: "white"
            }
          }],
          xAxes: [{
            display: true,
            ticks: {
              fontColor: "white"
            }
          }]
      }
    }
  });
}

fetch('https://api.nomics.com/v1/currencies/sparkline?key=bb81b74065caa35a1cb8210b7c688767&start=' + escape(new Date(Date.now() - 24*60*60*1000).toISOString()))
  .then(function(response) {
    return response.json();
  })
  .catch(function(error) {
    console.error(error);
  })
  .then(function(json) {
    if (Array.isArray(json)) {
      var daiData = json.find(function(elem) {
        return elem.currency == 'DAI';
      });
      if (daiData)
        createChart(daiData.timestamps, daiData.prices.map(function(p) { return parseFloat(p); }));
    }
  });

